<template>
    <UiAirportTabs id="SbAirportTabs" :blok="blok" />
</template>

<script setup>
defineProps({ blok: Object });
</script>

<style lang="postcss" scoped>
#SbAirportTabs {
    @apply flex justify-center;

    &.evenly-center {
        :deep(.container) {
            .tabs {
                .tabs-control {
                    @apply w-full;
                }
                .tab {
                    @apply flex-[1_1_0] mx-0 border-b-2 border-b-[#E9E9F0];
                    &.active {
                        @apply border-b-2 border-b-[var(--underline-color)];
                    }
                }
            }
        }
    }
    :deep(.container) {
        @apply pb-14 w-full;
        h3 {
            @apply text-center mt-10 text-2xl md:text-[40px] text-[#343a40] font-normal leading-[4rem];
        }
        .tabs-arrow-btn--right {
            @apply left-[95%];
        }
        .tabs-arrow-btn--left {
            @apply left-[5%];
        }
    }
}
</style>
